import { types } from './marcador.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'marcador',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'ID',
      value: {
        field: 'oid',
        header: 'ID',
        columnKey: 'oid',
        columnSortField: 'oid',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Código',
      value: {
        field: 'codigo',
        header: 'Código',
        columnKey: 'codigo',
        columnSortField: 'codigo',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
  ],
  columns: [],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'codigo',
      header: 'Descrição',
      columnKey: 'codigo',
      sortable: true,
      filter: true,
      columnSortField: 'codigo',
      visible: true,
    },
  ],
  currentRecord: {
    oid: '',
    codigo: '',
    descricao: '',
    tipos: [],
    ativo: true,
  },
  lookupMarcador: {
    visible: false,
    modal: true,
    header: 'Marcador',
  },
  messages: null,
}

const reducer = new Reducer(initialState, types)

export function CRUDMarcadorReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('marcador')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.SET_LOOKUP_MARCADOR_VISIBLE:
      return setLoockupMarcadorVisible(state, action)
    case types.RESET:
      return reset(state, action)
    default:
      return state
  }
}

function setLoockupMarcadorVisible(state, action) {
  let lookupMarcador = state.lookupMarcador
  lookupMarcador = Object.assign({}, lookupMarcador, {
    visible: action.visible,
  })
  return Object.assign({}, state, { lookupMarcador: lookupMarcador })
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}
